module.exports = __webpack_public_path__ + "static/reddit-ae093617274983e696e9d1515f59b2e6.png";